export const useProfileInfoPlaceholder = ({
  enabled,
  t,
  isOwner,
  pageType,
}) => {
  if (!enabled) return null;
  if (pageType === "client") {
    return t(`common:bio.${isOwner ? "owner_client" : "guest_client"}`);
  } else if (pageType === "master") {
    return t(`common:bio.${isOwner ? "owner_pro" : "guest_pro"}`);
  } else {
    return "";
  }
};
